import { NavLink, useLocation } from 'react-router-dom'
import { motion } from 'motion/react'
import { Col, Container, Row } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons'
import animationVariants from '../lib/animationVariants'
import { useEffect } from 'react'

export default function Home () {
  const location = useLocation()
  const { direction } = location.state || {}

  useEffect(() => {
    if (location.state) {
      location.state.background = '#f9423a'
    } else {
      location.state = {
        background: '#f9423a'
      }
    }
  }, [location])

  return (
    <motion.div className='w-100 h-100' variants={animationVariants[direction]} initial='hidden' animate='visible' exit='exit'>
      <Container fluid className='w-100 h-100'>
        <Row as='section' id='intro' className='h-100'>
          <Col className='d-flex justify-content-center align-items-center flex-xl-row flex-column'>
            <div className='text-heading text-center'>
              The Journey of <br />Ames Construction
            </div>
            <div>
              <NavLink to='/ames-family-history' state={{ direction: 'left' }} className='intro-button'>
                Touch to start &nbsp; <FontAwesomeIcon icon={faChevronRight} />
              </NavLink>
            </div>
          </Col>
        </Row>
      </Container>
    </motion.div>
  )
}
